export const STAGE_CONFIG: StageConfig = {
  "service": "parley-admin",
  "stage": "prod",
  "version": "0.1.0",
  "configUrl": "https://get.atlas-config.mit.edu/?key=parley-admin",
  "isLocal": false,
  "auth": {
    "okta": {
      "issuer": "https://okta.mit.edu/oauth2/aus6sh93rjqnQuszg697",
      "clientId": "0oa11xf50y7RqF93j698",
      "redirectUri": "",
      "postLogoutRedirectUri": "",
      "scopes": [
        "address",
        "email",
        "mit:user:all.read",
        "offline_access",
        "openid",
        "phone",
        "profile"
      ]
    },
    "cognito": {
      "userPoolId": "us-east-1_bCu6BU8d2",
      "userPoolWebClientId": "0oa11xf50y7RqF93j698",
      "oauth": {
        "domain": "atlas-auth.mit.edu",
        "scope": [
          "openid"
        ],
        "responseType": "token",
        "redirectSignIn": "",
        "redirectSignOut": "",
        "options": {
          "AdvancedSecurityDataCollectionFlag": false
        }
      }
    }
  },
  "apis": {
    "regional": {
      "baseUrl": "https://api.mit.edu",
      "paths": {
        "academic-history@v1": "academic-history-v1",
        "academic-history@latest": "academic-history-v1",
        "access@v1": "access-v1",
        "access@latest": "access-v1",
        "account@v1": "account-v1",
        "account@latest": "account-v2",
        "account@v2": "account-v2",
        "accounts@v2": "accounts-v2",
        "accounts@latest": "accounts-v2",
        "appointment-history@v1": "appointment-history-v1",
        "appointment-history@latest": "appointment-history-v1",
        "atlas-ui@v1": "atlas-ui-v1",
        "atlas-ui@latest": "atlas-ui-v1",
        "canopy@v1": "canopy-v1",
        "canopy@latest": "canopy-v1",
        "cloud-accounts@v1": "cloud-accounts-v1",
        "cloud-accounts@latest": "cloud-accounts-v1",
        "commencement@v2": "commencement-v2",
        "commencement@latest": "commencement-v2",
        "course-scheduling@v1": "course-scheduling-v1",
        "course-scheduling@latest": "course-scheduling-v1",
        "courses@v1": "courses-v1",
        "courses@latest": "courses-v1",
        "covid19@v1": "covid19-v1",
        "covid19@latest": "covid19-v1",
        "digital-id@v1": "digital-id-v1",
        "digital-id@latest": "digital-id-v1",
        "docusign@v1": "docusign-v1",
        "docusign@latest": "docusign-v1",
        "elo-tracking@v1": "elo-tracking-v1",
        "elo-tracking@latest": "elo-tracking-v1",
        "elo@v1": "elo-v1",
        "elo@latest": "elo-v2",
        "elo@v2": "elo-v2",
        "event-checkin@v1": "event-checkin-v1",
        "event-checkin@latest": "event-checkin-v1",
        "feature@v1": "feature-v1",
        "feature@latest": "feature-v1",
        "feedback@v1": "feedback-v1",
        "feedback@latest": "feedback-v1",
        "finance@v1": "finance-v1",
        "finance@latest": "finance-v3",
        "finance@v3": "finance-v3",
        "forrester@v1": "forrester-v1",
        "forrester@latest": "forrester-v1",
        "frc@v1": "frc-v1",
        "frc@latest": "frc-v1",
        "gap-union@v1": "gap-union-v1",
        "gap-union@latest": "gap-union-v1",
        "grad-admission@v1": "grad-admission-v1",
        "grad-admission@latest": "grad-admission-v1",
        "guest-account@v1": "guest-account-v1",
        "guest-account@latest": "guest-account-v1",
        "housing@v1": "housing-v1",
        "housing@latest": "housing-v1",
        "iedison@v1": "iedison-v1",
        "iedison@latest": "iedison-v1",
        "impersonation@v1": "impersonation-v1",
        "impersonation@latest": "impersonation-v1",
        "ipia@v1": "ipia-v1",
        "ipia@latest": "ipia-v1",
        "leave@v1": "leave-v1",
        "leave@latest": "leave-v1",
        "lwlc@v1": "lwlc-v1",
        "lwlc@latest": "lwlc-v1",
        "medical@v1": "medical-v1",
        "medical@latest": "medical-v1",
        "membership@v1": "membership-v1",
        "membership@latest": "membership-v1",
        "mitid@v2": "mitid-v2",
        "mitid@latest": "mitid-v2",
        "mitsis-prereg-api@v1": "mitsis-prereg-api-v1",
        "mitsis-prereg-api@latest": "mitsis-prereg-api-v1",
        "mitsis-prereg-canvas@v1": "mitsis-prereg-canvas-v1",
        "mitsis-prereg-canvas@latest": "mitsis-prereg-canvas-v1",
        "moira@v2": "moira-v2",
        "moira@latest": "moira-v2",
        "name-speak@v1": "name-speak-v1",
        "name-speak@latest": "name-speak-v1",
        "notification@v1": "notification-v1",
        "notification@latest": "notification-v1",
        "ogs-canvas@v1": "ogs-canvas-v1",
        "ogs-canvas@latest": "ogs-canvas-v1",
        "onboarding@v1": "onboarding-v1",
        "onboarding@latest": "onboarding-v2",
        "onboarding@v2": "onboarding-v2",
        "open-enrollment@v1": "open-enrollment-v1",
        "open-enrollment@latest": "open-enrollment-v1",
        "pass@v1": "pass-v1",
        "pass@latest": "pass-v1",
        "pdf-generator@v1": "pdf-generator-v1",
        "pdf-generator@latest": "pdf-generator-v1",
        "people-search@v1": "people-search-v1",
        "people-search@latest": "people-search-v1",
        "personal-information@v1": "personal-information-v1",
        "personal-information@latest": "personal-information-v1",
        "pfmla-export@v1": "pfmla-export-v1",
        "pfmla-export@latest": "pfmla-export-v1",
        "photos@v1": "photos-v1",
        "photos@latest": "photos-v1",
        "physical-security@v1": "physical-security-v1",
        "physical-security@latest": "physical-security-v1",
        "pi-dash@v1": "pi-dash-v1",
        "pi-dash@latest": "pi-dash-v1",
        "preferences@v1": "preferences-v1",
        "preferences@latest": "preferences-v1",
        "profile@v1": "profile-v1",
        "profile@latest": "profile-v1",
        "registration@v1": "registration-v1",
        "registration@latest": "registration-v1",
        "reports@v1": "reports-v1",
        "reports@latest": "reports-v1",
        "research@v1": "research-v1",
        "research@latest": "research-v1",
        "roles@v2": "roles-v2",
        "roles@latest": "roles-v2",
        "sap-proxy@v2": "sap-proxy-v2",
        "sap-proxy@latest": "sap-proxy-v2",
        "scheduling@v1": "scheduling-v1",
        "scheduling@latest": "scheduling-v1",
        "search@v1": "search-v1",
        "search@latest": "search-v1",
        "section-signup-api@v1": "section-signup-api-v1",
        "section-signup-api@latest": "section-signup-api-v1",
        "section-signup-canvas@v1": "section-signup-canvas-v1",
        "section-signup-canvas@latest": "section-signup-canvas-v1",
        "servicenow-chat@v1": "servicenow-chat-v1",
        "servicenow-chat@latest": "servicenow-chat-v1",
        "sloan@v1": "sloan-v1",
        "sloan@latest": "sloan-v1",
        "spaces@v4": "spaces-v4",
        "spaces@latest": "spaces-v4",
        "starrez@v1": "starrez-v1",
        "starrez@latest": "starrez-v1",
        "statuspage@v1": "statuspage-v1",
        "statuspage@latest": "statuspage-v1",
        "system-events@v1": "system-events-v1",
        "system-events@latest": "system-events-v1",
        "techcash@v1": "techcash-v1",
        "techcash@latest": "techcash-v1",
        "text@v1": "text-v1",
        "text@latest": "text-v1",
        "time-portal@v1": "time-portal-v1",
        "time-portal@latest": "time-portal-v1",
        "tlo@v1": "tlo-v1",
        "tlo@latest": "tlo-v1",
        "training@v2": "training-v2",
        "training@latest": "training-v2",
        "travel@v1": "travel-v1",
        "travel@latest": "travel-v1",
        "under-recovery@v1": "under-recovery-v1",
        "under-recovery@latest": "under-recovery-v1",
        "unicard-kiosk@v1": "unicard-kiosk-v1",
        "unicard-kiosk@latest": "unicard-kiosk-v1",
        "vaccine@v1": "vaccine-v1",
        "vaccine@latest": "vaccine-v2",
        "vaccine@v2": "vaccine-v2",
        "visiting-student@v1": "visiting-student-v1",
        "visiting-student@latest": "visiting-student-v1",
        "visitor@v1": "visitor-v1",
        "visitor@latest": "visitor-v2",
        "visitor@v2": "visitor-v2",
        "voip@v2": "voip-v2",
        "voip@latest": "voip-v2"
      }
    },
    "global": {
      "baseUrl": "https://parley-admin-global.api.mit.edu",
      "paths": {
        "academic-history@v1": "academic-history/v1",
        "academic-history@latest": "academic-history/v1",
        "account@v2": "account/v2",
        "account@latest": "account/v2",
        "acp-metrics@v1": "acp-metrics/v1",
        "acp-metrics@latest": "acp-metrics/v1",
        "alexandria@v1": "alexandria/v1",
        "alexandria@latest": "alexandria/v1",
        "apollo@v1": "apollo/v1",
        "apollo@latest": "apollo/v1",
        "appointment-history@v1": "appointment-history/v1",
        "appointment-history@latest": "appointment-history/v1",
        "atlas-message-bus@v1": "atlas-message-bus/v1",
        "atlas-message-bus@latest": "atlas-message-bus/v1",
        "atlas-ui@v1": "atlas-ui/v1",
        "atlas-ui@latest": "atlas-ui/v1",
        "canvas-extended-access-launch@v1": "canvas-extended-access-launch/v1",
        "canvas-extended-access-launch@latest": "canvas-extended-access-launch/v1",
        "canvas-extended-access@v1": "canvas-extended-access/v1",
        "canvas-extended-access@latest": "canvas-extended-access/v1",
        "canvas-membership-launch@v1": "canvas-membership-launch/v1",
        "canvas-membership-launch@latest": "canvas-membership-launch/v1",
        "canvas-membership@v1": "canvas-membership/v1",
        "canvas-membership@latest": "canvas-membership/v1",
        "canvas-mitsis-prereg-launch@v1": "canvas-mitsis-prereg-launch/v1",
        "canvas-mitsis-prereg-launch@latest": "canvas-mitsis-prereg-launch/v1",
        "canvas-mitsis-prereg@v1": "canvas-mitsis-prereg/v1",
        "canvas-mitsis-prereg@latest": "canvas-mitsis-prereg/v1",
        "canvas-photos-launch@v2": "canvas-photos-launch/v2",
        "canvas-photos-launch@latest": "canvas-photos-launch/v2",
        "canvas-photos@v2": "canvas-photos/v2",
        "canvas-photos@latest": "canvas-photos/v2",
        "canvas-section-signup-launch@v1": "canvas-section-signup-launch/v1",
        "canvas-section-signup-launch@latest": "canvas-section-signup-launch/v1",
        "canvas-section-signup@v1": "canvas-section-signup/v1",
        "canvas-section-signup@latest": "canvas-section-signup/v1",
        "cart@v1": "cart/v1",
        "cart@latest": "cart/v1",
        "cloud-accounts@v1": "cloud-accounts/v1",
        "cloud-accounts@latest": "cloud-accounts/v2",
        "cloud-accounts@v2": "cloud-accounts/v2",
        "commencement-public@v1": "commencement-public/v1",
        "commencement-public@latest": "commencement-public/v1",
        "commencement@v1": "commencement/v1",
        "commencement@latest": "commencement/v1",
        "course-scheduling@v1": "course-scheduling/v1",
        "course-scheduling@latest": "course-scheduling/v1",
        "digital-id@v1": "digital-id/v1",
        "digital-id@latest": "digital-id/v1",
        "direct-deposit-notif@v1": "direct-deposit-notif/v1",
        "direct-deposit-notif@latest": "direct-deposit-notif/v1",
        "direct-deposit@v1": "direct-deposit/v1",
        "direct-deposit@latest": "direct-deposit/v1",
        "dsmlo@v1": "dsmlo/v1",
        "dsmlo@latest": "dsmlo/v1",
        "dynamic-links@v1": "dynamic-links/v1",
        "dynamic-links@latest": "dynamic-links/v1",
        "ebuilder-integrations@v1": "ebuilder-integrations/v1",
        "ebuilder-integrations@latest": "ebuilder-integrations/v1",
        "ebuilder-sap-proxy@v1": "ebuilder-sap-proxy/v1",
        "ebuilder-sap-proxy@latest": "ebuilder-sap-proxy/v1",
        "ebuilder-sftp@v1": "ebuilder-sftp/v1",
        "ebuilder-sftp@latest": "ebuilder-sftp/v1",
        "event-hosting@v1": "event-hosting/v1",
        "event-hosting@latest": "event-hosting/v1",
        "example@v3": "example/v3",
        "example@latest": "example/v3",
        "feature@v1": "feature/v1",
        "feature@latest": "feature/v1",
        "files@v1": "files/v1",
        "files@latest": "files/v1",
        "finance@v3": "finance/v3",
        "finance@latest": "finance/v3",
        "forrester@v1": "forrester/v1",
        "forrester@latest": "forrester/v1",
        "frc@v2": "frc/v2",
        "frc@latest": "frc/v2",
        "fwsTimesheet@v1": "fwsTimesheet/v1",
        "fwsTimesheet@latest": "fwsTimesheet/v1",
        "gap-union@v1": "gap-union/v1",
        "gap-union@latest": "gap-union/v1",
        "gmat-score-api@v1": "gmat-score-api/v1",
        "gmat-score-api@latest": "gmat-score-api/v1",
        "grad-admissions@v1": "grad-admissions/v1",
        "grad-admissions@latest": "grad-admissions/v1",
        "guest-account@v2": "guest-account/v2",
        "guest-account@latest": "guest-account/v2",
        "iedison@v1": "iedison/v1",
        "iedison@latest": "iedison/v1",
        "impersonation@v1": "impersonation/v1",
        "impersonation@latest": "impersonation/v1",
        "ipia@v1": "ipia/v1",
        "ipia@latest": "ipia/v1",
        "leave@v1": "leave/v1",
        "leave@latest": "leave/v1",
        "legal-agent@v1": "legal-agent/v1",
        "legal-agent@latest": "legal-agent/v1",
        "librechat-config-api@v1": "librechat-config-api/v1",
        "librechat-config-api@latest": "librechat-config-api/v1",
        "lwlc@v1": "lwlc/v1",
        "lwlc@latest": "lwlc/v1",
        "mit-coupa-integration@v1": "mit-coupa-integration/v1",
        "mit-coupa-integration@latest": "mit-coupa-integration/v1",
        "mit-courses@v1": "mit-courses/v1",
        "mit-courses@latest": "mit-courses/v1",
        "mit-degree-audit@v1": "mit-degree-audit/v1",
        "mit-degree-audit@latest": "mit-degree-audit/v1",
        "mit-degrees@v1": "mit-degrees/v1",
        "mit-degrees@latest": "mit-degrees/v1",
        "mit-fragomen-i9@v1": "mit-fragomen-i9/v1",
        "mit-fragomen-i9@latest": "mit-fragomen-i9/v1",
        "mit-lms@v1": "mit-lms/v1",
        "mit-lms@latest": "mit-lms/v1",
        "mit-lumapps@v1": "mit-lumapps/v1",
        "mit-lumapps@latest": "mit-lumapps/v1",
        "mit-medical@v1": "mit-medical/v1",
        "mit-medical@latest": "mit-medical/v1",
        "mit-people-api@v1": "mit-people-api/v1",
        "mit-people-api@latest": "mit-people-api/v1",
        "mit-student-minors@v1": "mit-student-minors/v1",
        "mit-student-minors@latest": "mit-student-minors/v1",
        "mit-terms@v1": "mit-terms/v1",
        "mit-terms@latest": "mit-terms/v1",
        "mitid@v1": "mitid/v1",
        "mitid@latest": "mitid/v2",
        "mitid@v2": "mitid/v2",
        "moira@v2": "moira/v2",
        "moira@latest": "moira/v2",
        "museum-payments@v1": "museum-payments/v1",
        "museum-payments@latest": "museum-payments/v1",
        "name-speak@v1": "name-speak/v1",
        "name-speak@latest": "name-speak/v1",
        "notification@v1": "notification/v1",
        "notification@latest": "notification/v1",
        "odyssey@v1": "odyssey/v1",
        "odyssey@latest": "odyssey/v1",
        "okta-inline-hook@v1": "okta-inline-hook/v1",
        "okta-inline-hook@latest": "okta-inline-hook/v1",
        "okta-resources@v1": "okta-resources/v1",
        "okta-resources@latest": "okta-resources/v1",
        "onboarding@v1": "onboarding/v1",
        "onboarding@latest": "onboarding/v2",
        "onboarding@v2": "onboarding/v2",
        "opa@v1": "opa/v1",
        "opa@latest": "opa/v1",
        "open-enrollment@v1": "open-enrollment/v1",
        "open-enrollment@latest": "open-enrollment/v1",
        "parking-backend@v1": "parking-backend/v1",
        "parking-backend@latest": "parking-backend/v1",
        "parking@v2": "parking/v2",
        "parking@latest": "parking/v2",
        "pdf-generator@v1": "pdf-generator/v1",
        "pdf-generator@latest": "pdf-generator/v1",
        "people-search@v1": "people-search/v1",
        "people-search@latest": "people-search/v1",
        "permissions@v1": "permissions/v1",
        "permissions@latest": "permissions/v1",
        "personal-information@v1": "personal-information/v1",
        "personal-information@latest": "personal-information/v2",
        "personal-information@v2": "personal-information/v2",
        "pfml-export@v1": "pfml-export/v1",
        "pfml-export@latest": "pfml-export/v1",
        "physical-security@v1": "physical-security/v1",
        "physical-security@latest": "physical-security/v1",
        "pi-dash@v1": "pi-dash/v1",
        "pi-dash@latest": "pi-dash/v2",
        "pi-dash@v2": "pi-dash/v2",
        "police-dashboard@v1": "police-dashboard/v1",
        "police-dashboard@latest": "police-dashboard/v1",
        "policy@v1": "policy/v1",
        "policy@latest": "policy/v1",
        "powerfaids-batch@v1": "powerfaids-batch/v1",
        "powerfaids-batch@latest": "powerfaids-batch/v1",
        "procurement@v1": "procurement/v1",
        "procurement@latest": "procurement/v1",
        "profile@v1": "profile/v1",
        "profile@latest": "profile/v1",
        "pub@v1": "pub/v1",
        "pub@latest": "pub/v1",
        "receipt-capture@v1": "receipt-capture/v1",
        "receipt-capture@latest": "receipt-capture/v1",
        "registrar-forms@v1": "registrar-forms/v1",
        "registrar-forms@latest": "registrar-forms/v1",
        "registration@v1": "registration/v1",
        "registration@latest": "registration/v1",
        "reports@v1": "reports/v1",
        "reports@latest": "reports/v1",
        "research-release@v1": "research-release/v1",
        "research-release@latest": "research-release/v1",
        "research-search@v2": "research-search/v2",
        "research-search@latest": "research-search/v2",
        "research@v1": "research/v1",
        "research@latest": "research/v1",
        "rfp@v2": "rfp/v2",
        "rfp@latest": "rfp/v2",
        "roles@v2": "roles/v2",
        "roles@latest": "roles/v3",
        "roles@v3": "roles/v3",
        "rustici-webhook@v1": "rustici-webhook/v1",
        "rustici-webhook@latest": "rustici-webhook/v1",
        "sap-proxy@v2": "sap-proxy/v2",
        "sap-proxy@latest": "sap-proxy/v2",
        "scanned-id@v1": "scanned-id/v1",
        "scanned-id@latest": "scanned-id/v1",
        "scheduling-backend@v1": "scheduling-backend/v1",
        "scheduling-backend@latest": "scheduling-backend/v1",
        "search@v1": "search/v1",
        "search@latest": "search/v1",
        "service-chatbot@v1": "service-chatbot/v1",
        "service-chatbot@latest": "service-chatbot/v1",
        "servicenow-chat@v1": "servicenow-chat/v1",
        "servicenow-chat@latest": "servicenow-chat/v2",
        "servicenow-chat@v2": "servicenow-chat/v2",
        "slate-updater@v1": "slate-updater/v1",
        "slate-updater@latest": "slate-updater/v1",
        "snowflake-reports@v1": "snowflake-reports/v1",
        "snowflake-reports@latest": "snowflake-reports/v1",
        "spaces@v4": "spaces/v4",
        "spaces@latest": "spaces/v4",
        "starrez-integrations@v1": "starrez-integrations/v1",
        "starrez-integrations@latest": "starrez-integrations/v1",
        "statuspage@v1": "statuspage/v1",
        "statuspage@latest": "statuspage/v1",
        "student-dashboard@v1": "student-dashboard/v1",
        "student-dashboard@latest": "student-dashboard/v1",
        "student-forms@v2": "student-forms/v2",
        "student-forms@latest": "student-forms/v2",
        "student-success@v1": "student-success/v1",
        "student-success@latest": "student-success/v1",
        "swim-test@v1": "swim-test/v1",
        "swim-test@latest": "swim-test/v1",
        "techcash@v1": "techcash/v1",
        "techcash@latest": "techcash/v1",
        "text@v2": "text/v2",
        "text@latest": "text/v2",
        "textbook@v1": "textbook/v1",
        "textbook@latest": "textbook/v1",
        "time-portal@v1": "time-portal/v1",
        "time-portal@latest": "time-portal/v1",
        "tlo-agreements@v2": "tlo-agreements/v2",
        "tlo-agreements@latest": "tlo-agreements/v2",
        "tlo-cases@v2": "tlo-cases/v2",
        "tlo-cases@latest": "tlo-cases/v2",
        "tlo-contacts@v2": "tlo-contacts/v2",
        "tlo-contacts@latest": "tlo-contacts/v2",
        "tlo-expenses@v2": "tlo-expenses/v2",
        "tlo-expenses@latest": "tlo-expenses/v2",
        "tlo-financial@v2": "tlo-financial/v2",
        "tlo-financial@latest": "tlo-financial/v2",
        "tlo-ocr@v1": "tlo-ocr/v1",
        "tlo-ocr@latest": "tlo-ocr/v1",
        "tlo-royalties@v2": "tlo-royalties/v2",
        "tlo-royalties@latest": "tlo-royalties/v2",
        "tlo@v1": "tlo/v1",
        "tlo@latest": "tlo/v2",
        "tlo@v2": "tlo/v2",
        "training@v2": "training/v2",
        "training@latest": "training/v2",
        "travel@v1": "travel/v1",
        "travel@latest": "travel/v1",
        "under-recovery-reports@v1": "under-recovery-reports/v1",
        "under-recovery-reports@latest": "under-recovery-reports/v1",
        "under-recovery@v1": "under-recovery/v1",
        "under-recovery@latest": "under-recovery/v1",
        "unicard-kiosk@v1": "unicard-kiosk/v1",
        "unicard-kiosk@latest": "unicard-kiosk/v1",
        "visiting-student@v1": "visiting-student/v1",
        "visiting-student@latest": "visiting-student/v1",
        "visitor@v2": "visitor/v2",
        "visitor@latest": "visitor/v2",
        "voip@v2": "voip/v2",
        "voip@latest": "voip/v2"
      }
    },
    "external": {}
  }
}

export type ApiPaths = Record<string, string>

export interface ApiEndpoint {
  baseUrl: string
  paths: ApiPaths
}

export interface ApiConfig {
  regional: ApiEndpoint
  global: ApiEndpoint
  external: ApiPaths
}

export interface OktaConfig {
  issuer: string
  clientId: string
  redirectUri: string
  postLogoutRedirectUri: string
  scopes: string[]
}

export interface CognitoConfig {
  userPoolId: string
  userPoolWebClientId: string
  oauth: {
    domain: string
    scope: string[]
    redirectSignIn?: string
    redirectSignOut?: string
    responseType: 'token'
    options: {
      AdvancedSecurityDataCollectionFlag: boolean
    }
  }
}

export enum AuthProvider {
  OKTA = 'okta',
  COGNITO = 'cognito'
}

export interface AuthConfig {
  [AuthProvider.OKTA]: OktaConfig
  [AuthProvider.COGNITO]: CognitoConfig
}

export interface StageConfig {
  service: string
  version: string
  stage: string
  configUrl: string
  isLocal: boolean
  auth: AuthConfig
  apis: ApiConfig
}

export interface AtlasConfig {
  'idp.okta.active': string
  'global.enabled': string
  'idp.cirrus.active': string
  'idp.cognito.active': string
}

export const DEFAULT_ATLAS_CONFIG: AtlasConfig = {
  'idp.okta.active': 'true',
  'idp.cognito.active': 'false',
  'idp.cirrus.active': 'false',
  'global.enabled': 'true'
}

let atlasConfig: AtlasConfig | null = null

export async function getAtlasConfig (): Promise<AtlasConfig> {
  if (atlasConfig !== null) {
    return atlasConfig
  }
  try {
    const response = await fetch(STAGE_CONFIG.configUrl)
    const data = await response.json() as AtlasConfig
    atlasConfig = data
  } catch (error) {
    console.error('Error fetching atlas config', error)
    atlasConfig = DEFAULT_ATLAS_CONFIG
  }
  return atlasConfig
}

export async function getActiveAuthProvider (): Promise<AuthProvider> {
  const atlasConfig = await getAtlasConfig()
  if (atlasConfig['idp.okta.active'] === 'true') {
    return AuthProvider.OKTA
  }
  if (atlasConfig['idp.cognito.active'] === 'true') {
    return AuthProvider.COGNITO
  }
  return AuthProvider.OKTA
}

export async function getCognitoConfig (): Promise<CognitoConfig> {
  const result = STAGE_CONFIG.auth.cognito
  result.oauth.redirectSignIn = getCurrentBaseUrl()
  result.oauth.redirectSignOut = getCurrentBaseUrl() + '/logout'
  return result
}

export async function getOktaConfig (): Promise<OktaConfig> {
  const result = STAGE_CONFIG.auth.okta
  result.redirectUri = getCurrentBaseUrl()
  result.postLogoutRedirectUri = getCurrentBaseUrl() + '/logout'
  return result
}

/**
 * Get the base url for an API. Find the baseUrl by providing the api name and version in
 * the format of `api-name[@v1]`.
 *
 * If the version is not provided or @latest is specified, it will return the path for the
 * latest version.
 *
 * @param api - The api name and version in the format of `api-name[@v1]`.
 * @returns The base url for the api.
 */
export async function getApiBaseUrl (api: string): Promise<string> {
  const baseUrls = await getApiBaseUrls()
  const key = api.includes('@') ? api : `${api}@latest`
  if (baseUrls[key] === undefined) {
    throw new Error(`API ${api} not found in baseUrls`)
  }
  return baseUrls[key]
}

export async function getApiBaseUrls (): Promise<Record<string, string>> {
  const atlasConfig = await getAtlasConfig()

  // Regional endpoints need to be used so always use the regional base url
  if (atlasConfig['global.enabled'] !== 'true') {
    return {
      ...addBaseUrls(STAGE_CONFIG.apis.regional.paths, STAGE_CONFIG.apis.regional.baseUrl),
      ...STAGE_CONFIG.apis.external
    }
  }

  // Local does not have a proxy set up to the API gateway, so we need to use the global base url
  if (STAGE_CONFIG.isLocal) {
    return {
      ...addBaseUrls(STAGE_CONFIG.apis.global.paths, STAGE_CONFIG.apis.global.baseUrl),
      ...STAGE_CONFIG.apis.external
    }
  }

  // Otherwise, AWS deployment will proxy through the CloudFront in the case of global
  return {
    ...addBaseUrls(STAGE_CONFIG.apis.global.paths, `${getCurrentBaseUrl()}/api`),
    ...STAGE_CONFIG.apis.external
  }
}

function addBaseUrls (paths: ApiPaths, baseUrl: string): Record<string, string> {
  const apiPaths: Array<[string, string]> = Object.entries(paths)
  const withBaseUrl: Array<[string, string]> = apiPaths.map(([key, path]) => ([
    key, `${baseUrl}/${path}`
  ]))
  const asMap = withBaseUrl.reduce<Record<string, string>>((acc, [key, path]) => ({
    ...acc,
    [key]: path
  }), {})
  return asMap
}

function getCurrentBaseUrl (): string {
  if (!('location' in globalThis)) {
    throw new Error('location not found in globalThis')
  }

  const location = (globalThis as any).location // eslint-disable-line @typescript-eslint/no-explicit-any
  const hostname: string = location.hostname
  const port: string = location.port
  if (hostname === 'localhost') {
    return `http://${hostname}:${port}`
  }

  return `https://${hostname}`
}
